// extracted by mini-css-extract-plugin
export default {"remove":"removableTag_remove__La0O7pjR","removeIcon":"removableTag_removeIcon__ZoCWnWki"};